import { registerSW } from "virtual:pwa-register";
import { t } from "./i18n.js";

let installPrompt = null;

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

function isIos() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

export function initInstall() {
  const launch = /** @type {HTMLButtonElement | null} */ (document.querySelector("#install-button"));
  const dialog = /** @type {HTMLDialogElement | null} */ (document.querySelector("#install-dialog"));
  const copy = /** @type {HTMLElement | null} */ (document.querySelector("#install-copy"));
  const confirm = /** @type {HTMLButtonElement | null} */ (document.querySelector("#install-confirm"));
  const close = /** @type {HTMLButtonElement | null} */ (document.querySelector("#install-close"));

  registerSW({
    immediate: true,
    onNeedRefresh() {
      document.documentElement.dataset.updateAvailable = "true";
    },
    onOfflineReady() {
      document.documentElement.dataset.offlineReady = "true";
    },
  });

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    installPrompt = event;
    launch?.removeAttribute("aria-disabled");
  });

  window.addEventListener("appinstalled", () => {
    installPrompt = null;
    dialog?.close();
    launch?.setAttribute("aria-disabled", "true");
  });

  launch?.addEventListener("click", () => {
    if (!copy || !confirm || !dialog) return;
    copy.textContent = isStandalone()
      ? t("install.done")
      : isIos()
        ? t("install.ios")
        : installPrompt
          ? t("install.ready")
          : t("install.desktop");
    confirm.hidden = isStandalone() || !installPrompt;
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "");
  });

  confirm?.addEventListener("click", async () => {
    if (!installPrompt || !dialog) return;
    await installPrompt.prompt();
    await installPrompt.userChoice;
    installPrompt = null;
    dialog.close();
  });
  close?.addEventListener("click", () => dialog?.close());
  dialog?.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });
}
